export enum ShelfColorsEnum {
  ALL = 'all',
  HIGH_GLOSS_WHITE = 'high-gloss-white',
  WHITE = 'white',
  OAK = 'oak',
  GRAY = 'gray',
  BLACK = 'black',
}
